<nb-card>
  <nb-card-header>
    <div>
      <button
        [ngClass]="menu == 'info' ? 'button-menu active' : 'button-menu'"
        [status]="menu == 'info' ? 'primary' : 'basic'"
        nbButton
        ghost
        nbTooltipPlacement="bottom"
        (click)="selectMenu('info')"
      >
        <nb-icon class="button-icon" icon="info-outline"></nb-icon>
        <span>{{ "common.info" | translate }}</span>
      </button>

      <button
        *ngIf="mode === 'edit'"
        [ngClass]="menu == 'content' ? 'button-menu active' : 'button-menu'"
        [status]="menu == 'content' ? 'primary' : 'basic'"
        nbButton
        ghost
        nbTooltipPlacement="bottom"
        (click)="selectMenu('content')"
      >
        <nb-icon class="button-icon" icon="file-text-outline"></nb-icon>
        <span>{{ "common.moreDetail" | translate }}</span>
      </button>
    </div>

    <button
      class="cancel"
      nbButton
      outline
      status="info"
      size="small"
      (click)="cancel()"
    >
      <nb-icon icon="close-outline"></nb-icon></button
  ></nb-card-header>
  <nb-card-body>
    <div *ngIf="menu == 'info'" class="row">
      <div class="col-12 col-md-6">
        <div class="form-group" [formGroup]="diaForm">
          <label for="inputFullname" class="label text-primary">
            Tên dự án
          </label>
          <input
            type="text"
            nbInput
            fullWidth
            id="inputFullname"
            class="form-control"
            placeholder="Nhập tên dự án"
            formControlName="title"
            [(ngModel)]="project.title"
          />
        </div>

        <div class="form-group">
          <div class="label">
            <label> Mô tả </label>
            <p class="text-hint">
              Tóm tắt nội dung ngắn gọn giới thiệu về dự án
            </p>
          </div>
          <textarea
            nbInput
            fullWidth
            id="inputDescription"
            class="form-control"
            [(ngModel)]="project.description"
          ></textarea>
        </div>

        <div class="form-group">
          <label class="label">
            Hình đại diện
            <button
              nbButton
              ghost
              size="none"
              status="danger"
              [disabled]="submitted"
              [class.btn-pulse]="submitted"
              (click)="removeCoverUrl()"
            >
              <nb-icon icon="trash-2-outline"></nb-icon>
            </button>
          </label>
          <ngx-upload-image
            [size]="'tiny'"
            [mode]="'imagekit'"
            [path]="'/project/cover'"
            [imageURL]="imageURL"
            (onUploadSuccess)="updateImage($event)"
          ></ngx-upload-image>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="form-group">
          <label class="label text-primary"> Ngày bắt đầu </label>
          <nb-form-field>
            <input
              nbInput
              shape="semi-round"
              fieldSize="small"
              [nbDatepicker]="startDate"
              [(ngModel)]="project.startDate"
            />
            <nb-datepicker #startDate format="dd/MM/yyyy"></nb-datepicker>
          </nb-form-field>
        </div>
        <div class="form-group">
          <label class="label text-primary"> Ngày kết thúc </label>
          <nb-form-field>
            <input
              nbInput
              shape="semi-round"
              fieldSize="small"
              [nbDatepicker]="endDate"
              [(ngModel)]="project.endDate"
            />
            <nb-datepicker #endDate format="dd/MM/yyyy"></nb-datepicker>
          </nb-form-field>
        </div>
        <div class="form-group">
          <label class="label text-primary">
            Ngân sách
            <!-- <span class="text-danger">{{ project.budget | number }} </span> -->
          </label>
          <input
            type="text"
            nbInput
            fullWidth
            class="form-control"
            [(ngModel)]="project.budget"
            [ngxNumberFormat]="formatCurrency"
          />
        </div>
      </div>
    </div>

    <div *ngIf="menu == 'info'" class="row">
      <div class="col-12">
        <button
          [ngClass]="subMenu == 'why' ? 'button-menu active' : 'button-menu'"
          [status]="subMenu == 'why' ? 'primary' : 'basic'"
          nbButton
          ghost
          nbTooltipPlacement="bottom"
          (click)="selectSubMenu('why')"
        >
          <label class="text-danger">1. WHY - Tại sao?</label>
        </button>
        <button
          [ngClass]="subMenu == 'how' ? 'button-menu active' : 'button-menu'"
          [status]="subMenu == 'how' ? 'primary' : 'basic'"
          nbButton
          ghost
          nbTooltipPlacement="bottom"
          (click)="selectSubMenu('how')"
        >
          <label class="text-warning">2. HOW - Làm thế nào?</label>
        </button>
        <button
          [ngClass]="subMenu == 'what' ? 'button-menu active' : 'button-menu'"
          [status]="subMenu == 'what' ? 'primary' : 'basic'"
          nbButton
          ghost
          nbTooltipPlacement="bottom"
          (click)="selectSubMenu('what')"
        >
          <label class="text-primary">3. WHAT - Giá trị gì?</label>
        </button>
        <button
          [ngClass]="
            subMenu == 'purpose' ? 'button-menu active' : 'button-menu'
          "
          [status]="subMenu == 'purpose' ? 'primary' : 'basic'"
          nbButton
          ghost
          nbTooltipPlacement="bottom"
          (click)="selectSubMenu('purpose')"
        >
          <label class="text-success">4. Mục tiêu</label>
        </button>
        <button
          [ngClass]="subMenu == 'rules' ? 'button-menu active' : 'button-menu'"
          [status]="subMenu == 'rules' ? 'primary' : 'basic'"
          nbButton
          ghost
          nbTooltipPlacement="bottom"
          (click)="selectSubMenu('rules')"
        >
          <label class="text-danger">5. Quy định</label>
        </button>

        <div *ngIf="subMenu == 'why'" class="form-group">
          <div class="label">
            <p class="text-hint">
              Hãy bắt đầu với các câu hỏi Tại sao? và tìm các câu trả lời làm
              ĐỘNG LỰC để bắt đầu dự án
            </p>
          </div>
          <ngx-editor-document [(ngModel)]="project.why"></ngx-editor-document>
        </div>

        <div *ngIf="subMenu == 'how'" class="form-group">
          <div class="label">
            <p class="text-hint">
              Nêu ra toàn bộ các trường hợp, các giải pháp khi thực hiện dự án
            </p>
          </div>
          <ngx-editor-document [(ngModel)]="project.how"></ngx-editor-document>
        </div>

        <div *ngIf="subMenu == 'what'" class="form-group">
          <div class="label">
            <p class="text-hint">
              Những kết quả, giá trị nào bạn sẽ đạt được khi thực hiện dự án
              này?
            </p>
          </div>
          <ngx-editor-document [(ngModel)]="project.what"></ngx-editor-document>
        </div>

        <div *ngIf="subMenu == 'purpose'" class="form-group">
          <div class="label">
            <p class="text-hint">
              Hãy nêu ra các mục tiêu SMART ( cụ thể và có thể thực hiện được)
            </p>
          </div>
          <ngx-editor-document
            [(ngModel)]="project.purpose"
          ></ngx-editor-document>
        </div>

        <div *ngIf="subMenu == 'rules'" class="form-group">
          <div class="label">
            <p class="text-hint">
              Hãy nêu ra các quy định thưởng và phạt để tạo THÁI ĐỘ KỸ LUẬT khi
              thực hiện, sẽ giúp bạn hoàn thành tốt công việc
            </p>
          </div>
          <ngx-editor-document
            [(ngModel)]="project.rules"
          ></ngx-editor-document>
        </div>
      </div>
    </div>

    <div *ngIf="menu == 'content'" class="row">
      <div class="col-12">
        <div class="form-group">
          <div class="label">
            <label class="text-primary">Ghi chú</label>
          </div>
          <ngx-editor-document
            [(ngModel)]="project.content"
          ></ngx-editor-document>
        </div>
        <div class="form-group">
          <div class="label">
            <label class="text-primary">Thông tin liên lạc</label>
          </div>
          <ngx-view-persons
            [shopId]="shopId"
            [mode]="'project'"
            [refId]="project.id"
            [refName]="project.title"
          ></ngx-view-persons>
        </div>
      </div>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <button
      type="submit"
      nbButton
      status="primary"
      size="small"
      [disabled]="submitted || !diaForm.valid"
      [class.btn-pulse]="submitted"
      (click)="submit()"
    >
      <nb-icon icon="save-outline"></nb-icon>
      {{ "buttons.save" | translate }}
    </button>

    <button
      *ngIf="mode === 'edit'"
      nbButton
      status="danger"
      size="small"
      [disabled]="submitted || !diaForm.valid"
      [class.btn-pulse]="submitted"
      (click)="delete(project)"
    >
      <nb-icon icon="trash-2-outline"></nb-icon>
      {{ "buttons.delete" | translate }}
    </button>
  </nb-card-footer>
</nb-card>
